/**
 * @module api/domain/partner
 * @description 파트너 관련 API
 *   - 파트너 리스트/상세 조회, 파트너 등록/수정
 *   - 수리파트너 소속 및 관리자 소속에 파트너 배정
 */
import { getApi, api } from '@/api/api'

/** 파트너 리스트 조회 */
export const getPartnerList = async (serviceType) => {
  const url = '/user/partner/code_all?serviceType=' + serviceType
  return await getApi(url)
}

/** 모든 파트너 리스트 조회 */
export const getAllPartnerList = async () => {
  const url = '/user/partner/code_all'
  return await getApi(url)
}

/** 파트너 상세 조회 */
export const getPartnerDetail = async (partnerId) => {
  const url = `/user/partner/${partnerId}`
  return await getApi(url)
}

/** 파트너 등록 */
export const savePartner = async (method, data) => {
  const url = '/user/partner'
  return await api(url, method, data)
}

/** 파트너 수정 */
export const updatePartner = async (partnerId, method, data) => {
  const url = `/user/partner/${partnerId}`
  return await api(url, method, data)
}

/** 수리파트너 소속에 파트너 배정 */
export const saveStaffTeamAllocationPartner = async (StaffTeamId, method, data) => {
  const url = `/repair-staff-team-partner/relation/${StaffTeamId}`
  return await api(url, method, data)
}

/** 관리자 소속에 파트너 배정 */
export const saveAdminTeamAllocationPartner = async (userGroupId, method, data) => {
  const url = `/user-groups/partner/allocation/${userGroupId}`
  return await api(url, method, data)
}
